import { render, staticRenderFns } from "./ChatUserProfile.vue?vue&type=template&id=721dfbcd&scoped=true"
import script from "./ChatUserProfile.vue?vue&type=script&lang=js"
export * from "./ChatUserProfile.vue?vue&type=script&lang=js"
import style0 from "./ChatUserProfile.vue?vue&type=style&index=0&id=721dfbcd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721dfbcd",
  null
  
)

export default component.exports